import { inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { ResourceBundleService } from '../modules/core/services/resource-bundle.service';
import { ResolveFn } from '@angular/router';

export const pDetailContentResolver: ResolveFn<any> = (): Observable<boolean> => {
	const contentService: ResourceBundleService = inject(ResourceBundleService);
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	
    if (!contentService.isPDetailContentPopulated) {
		store.dispatch(new olci.LoadPdetailContentAction());
	}

	return store.pipe(select(fromRoot.getContentState)).pipe(
		filter(s => !s.loadingPDetailContent),
		take(1),
		map(content => {
			if (content.error) {
				store.dispatch(new olci.NavigateToError());
				return false;
			} else {
				return true;
			}
		})
	); 
}
